import React from "react";
import { CmmOrderTableRowData } from "../../../../../data-model/cmmOrderTableRowData";
import { usePrescriptionDetails } from "../hooks/usePrescriptionDetails";
import { MedicationProps } from "../types";
import {
  ErrorState,
  LoadingState,
  MedicationHeader,
  PrescriptionDetailsContent,
} from "./ui";

const Prescription: React.FC<MedicationProps> = ({ rowData }) => {
  const { patientDetails, drugDetails, loading, error } =
    usePrescriptionDetails({
      rowId: rowData?.id,
    });

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-2 border-1 border-primaryGray-15 bg-[#F7F9FA]">
      <MedicationHeader data={rowData as CmmOrderTableRowData} />
      <div className="flex h-full w-full flex-col items-center justify-center bg-primaryGray-16">
        {loading ? (
          <LoadingState message="Loading prescription data..." />
        ) : error ? (
          <ErrorState error={error} />
        ) : (
          <PrescriptionDetailsContent
            patientDetails={patientDetails}
            drugDetails={drugDetails}
          />
        )}
      </div>
    </div>
  );
};

export default Prescription;
